export default state => state.payment.shouldShowPaymentCategorySelectBoxes;
